import { CSSProperties } from "react";
import { ReactComponent as LogoWindows10 } from "#src/assets/images/logos/logo-windows-10.svg";
import { ReactComponent as LogoApple } from "#src/assets/images/logos/logo-apple.svg";
import { ReactComponent as LogoUbuntu } from "#src/assets/images/logos/logo-ubuntu.svg";
import { ReactComponent as LogoAndroid } from "#src/assets/images/logos/logo-android.svg";

export enum OsEnum {
  WINDOWS = "windows",
  APPLE = "darwin",
  UBUNTU = "ubuntu",
  ANDROID = "android",
}

/**
 * @param value - name of OS
 * @param size - size (calculate by rem)
 */
export const getOsIcon = (value: string, size: number) => {
  const styleProps: CSSProperties = {
    height: size + "rem",
    width: size + "rem",
    minWidth: size + "rem",
  };

  if (value === OsEnum.WINDOWS) return <LogoWindows10 style={styleProps} />;
  if (value === OsEnum.APPLE) return <LogoApple style={styleProps} />;
  if (value === OsEnum.UBUNTU) return <LogoUbuntu style={styleProps} />;
  if (value === OsEnum.ANDROID) return <LogoAndroid style={styleProps} />;

  return null;
};
